<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SkistarAccommodationImages',
  computed: {
    ...mapState({
      accommodation: state => state.skistar.accommodation.selected,
      show: state => state.skistar.accommodation.images.show,
      loading: state => state.skistar.accommodation.images.itemsLoading,
      images: state => state.skistar.accommodation.images.items,
    }),
    importedImages() {
      return Object.values(this.images)
        .filter(image => !image.isNoLongerPartOfImport && image.active);
    },
    nonImportedImages() {
      return Object.values(this.images)
        .filter(image => !image.isNoLongerPartOfImport && !image.active);
    },
  },
  methods: {
    ...mapActions({
      closeImages: 'skistar/closeAccommodationImages',
      activateImage: 'skistar/activateAccommodationImage',
      deactivateImage: 'skistar/deactivateAccommodationImage',
      deleteImage: 'skistar/deleteAccommodationImage',
    }),
  },
};
</script>

<template>
  <v-layout>
    <v-flex xs12 class="text-xs-right">
      <v-dialog
        v-model="show"
        width="1000"
        @input="closeImages"
      >
        <v-card tile>
          <v-layout row>
            <v-flex>
              <v-card-title class="modal-title">
                {{ accommodation.name }}, {{ accommodation.description }}
              </v-card-title>
            </v-flex>
            <v-flex>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="red darken-1"
                  flat
                  @click="closeImages"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
          <v-card-text>
            <v-progress-linear
              v-if="loading && Object.keys(images).length === 0"
              indeterminate
            />
            <template v-else>
              <v-container
                v-if="nonImportedImages.length"
                grid-list-sm
                fluid
              >
                <h2>Non imported images</h2>
                <v-layout row wrap>
                  <v-flex
                    v-for="image in nonImportedImages"
                    :key="image.identifier"
                    xs4
                  >
                    <v-card flat tile>
                      <v-img
                        :src="image.imageUrl"
                        height="160px"
                        class="non-imported-image"
                      >
                        <v-layout class="image-controls">
                          <v-btn
                            :href="image.imageUrl"
                            color="white"
                            target="_blank"
                            icon
                            fab
                            small
                            class="view-button"
                          ><v-icon>crop_original</v-icon>
                          </v-btn>
                          <label class="toggle-switch">
                            <input
                              :checked="image.active"
                              :disabled="loading"
                              type="checkbox"
                              @change="activateImage(image.identifier)"
                            >
                            <span :class="{ 'active': image.active }" class="slider"/>
                          </label>
                        </v-layout>
                      </v-img>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container
                v-if="importedImages.length"
                grid-list-sm
                fluid
              >
                <h2>Imported images</h2>
                <v-layout row wrap>
                  <v-flex
                    v-for="image in importedImages"
                    :key="image.identifier"
                    xs4
                  >
                    <v-card flat tile>
                      <v-img
                        :src="image.imageUrl"
                        height="160px"
                      >
                        <v-layout class="image-controls">
                          <v-btn
                            :href="image.imageUrl"
                            color="white"
                            target="_blank"
                            icon
                            fab
                            small
                            class="view-button"
                          ><v-icon>crop_original</v-icon>
                          </v-btn>
                          <label class="toggle-switch">
                            <input
                              :checked="image.active"
                              :disabled="loading"
                              type="checkbox"
                              @change="deactivateImage(image.identifier)"
                            >
                            <span :class="{ 'active': image.active }" class="slider"/>
                          </label>
                        </v-layout>
                      </v-img>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </template>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<style scoped lang="scss">
  @import '../../../assets/scss/variables';

  .modal-title {
    font-size: $font-size-md;
  }

  .non-imported-image {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.1);
      pointer-events: none;
    }
  }

  .image-controls {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    padding: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .view-button {
    margin-left: 8px;
  }

  .toggle-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
    margin-right: 8px;
  }

  .toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ff5252;
    transition: .4s;
    border-radius: 24px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }

  .slider.active {
    background-color: #4caf50;
  }

  .slider.active:before {
    transform: translateX(26px);
  }

  input:disabled + .slider {
    opacity: 0.5;
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarAccommodationImages.vue